
import { useEffect, useState, useRef } from 'react';

export default function ZeroRetention() {
  const [animated, setAnimated] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (animated) {
      const interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % 4);
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [animated]);

  const policies = [
    {
      title: 'No content logs',
      description: 'We log timestamps, not content',
    },
    {
      title: 'No training',
      description: 'Your documents never train our AI',
    },
    {
      title: 'No backups',
      description: 'No archive of processed documents',
    },
    {
      title: 'No exceptions',
      description: 'We cannot retrieve documents after processing',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="font-harvey-serif text-white text-3xl sm:text-[42px] font-normal tracking-tight text-center mb-16 sm:mb-20">
          Zero Data Retention
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          {policies.map((policy, index) => (
            <div
              key={index}
              className={`p-6 sm:p-8 bg-[#0f0f11] border rounded-xl transition-all duration-500 ${
                activeIndex === index
                  ? 'border-[#06b6d4] shadow-[0_0_40px_rgba(6,182,212,0.2)]'
                  : 'border-[#1a1a1c]'
              } ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <h3 className="font-harvey-serif text-white text-xl sm:text-2xl font-normal tracking-tight mb-3">
                {policy.title}
              </h3>
              <p className="font-harvey-sans text-[#a1a1aa] text-base sm:text-lg font-light tracking-wide">{policy.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
